import { useState } from "react";
import { api } from "./api";

export default function Login({ onLogin }) {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    async function submit(e) {
        e.preventDefault();
        setError("");
        try {
            await api.login(password);
            onLogin?.();
        } catch (err) {
            setError(String(err?.message || err));
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center p-6">
            <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl border p-4 space-y-3">
                <div className="font-semibold text-lg">Connexion</div>

                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full border rounded-xl p-3"
                    placeholder="Mot de passe"
                />

                {error ? <div className="text-sm text-red-600">{error}</div> : null}

                <button className="w-full bg-gray-900 text-white rounded-xl p-3 font-semibold">
                    Se connecter
                </button>
            </form>
        </div>
    );
}
